<template>
    <lightbox-gallery-slide class="lightbox-media-gallery-slide">

        <img
            class="media"
            :src="media.url"
            v-if="media.type === 'image'">

        <template v-if="media.type === 'video'">
            <div
                class="media media-fixed-ratio ratio-16-9"
                v-html="iframeHtml"
                v-if="iframe">
            </div>
            <video
                class="media"
                :src="media.url"
                @error="onVideoError"
                v-else>
            </video>
        </template>

        <div
            class="media"
            v-html="media.html"
            v-if="media.type === 'iframe'">
        </div>

        <div
            class="media media-fixed-ratio ratio-16-9"
            v-html="iframeHtml"
            v-if="media.type === 'sketchfab'">
        </div>

        <div
            class="media media-fixed-ratio ratio-8-6"
            v-if="media.type === 'marmoset'">

            <marmoset-viewer :src="media.url"></marmoset-viewer>
        </div>

        <p
            class="media-error"
            v-if="media.type === 'error' || iframeError">
            {{ media.message || iframeError }}
        </p>

        <p
            class="media-caption"
            v-if="media.caption">
            {{ media.caption }}
        </p>

    </lightbox-gallery-slide>
</template>

<script>
    import Noembed              from '../../../services/noembed';
    import Sketchfab            from '../../../services/sketchfab';
    import MarmosetViewer       from '../../widgets/MarmosetViewer';
    import LightboxGallerySlide from './gallery-slide';

    // TODO: show loading animation when loading iframe

    class IframeLoader {
        constructor(type, url) {
            this._html = null;
            this._error = null;

            const load = async () => {
                function removeSizeAttr(html) {
                    return html.replace(/(width|height)=".+?"/g, '');
                }

                if (type === 'video') {
                    await Noembed.getInfo(url).then(info => {
                        this._html = removeSizeAttr(info.html);
                    }, error => {
                        this._error = error;
                    });

                } else if (type === 'sketchfab') {
                    await Sketchfab.getInfo(url).then(info => {
                        this._html = removeSizeAttr(info.html);
                    }, error => {
                        this._error = error;
                    });

                } else {
                    this._error = new Error(
                        `unknown type "${type}" in iframe loader`
                    );
                }
            };
            this._promise = load();
        }

        get html() {
            return this._html;
        }

        get error() {
            return this._error;
        }
    }

    export default {
        props: {
            media: {
                type: Object, // Media (see MediaGallery component)
                required: true,
            },
        },

        components: {
            LightboxGallerySlide,
            MarmosetViewer,
        },

        data() {
            return {
                iframe: null,
            };
        },

        computed: {
            iframeHtml() {
                return this.iframe && this.iframe.html;
            },

            iframeError() {
                return this.iframe && this.iframe.error;
            },
        },

        methods: {
            /**
             * We first try to play videos using the <video> element. If that
             * fails, then we can try an <iframe> in case the video is actually
             * from YouTube or Vimeo.
             */
            onVideoError(err) {
                const MEDIA_ERR_SRC_NOT_SUPPORTED = 4;

                err = err && err.target && err.target.error;

                if (err && err.code === MEDIA_ERR_SRC_NOT_SUPPORTED) {
                    this.iframe = new IframeLoader(
                        this.media.type,
                        this.media.url,
                    );
                }
            },
        },

        watch: {
            media: {
                handler() {
                    const iframeTypes = ['sketchfab'];
                    if (iframeTypes.includes(this.media.type)) {
                        this.iframe = new IframeLoader(
                            this.media.type,
                            this.media.url,
                        );
                    } else {
                        this.iframe = null;
                    }
                },
                immediate: true,
            },
        },
    }
</script>

<style lang="scss" scoped>
    .lightbox-media-gallery-slide {
        flex-direction: column;
    }

    .media {
        display: block;
        margin: 0 auto;
        max-width: 90vw;
        max-height: 80vh; // Without this, the caption gets hidden
    }

    .media-fixed-ratio {
        position: relative;
        width: 100%;

        &.ratio-16-9::after {
            content: '';
            display: block;
            padding-top: calc(9 / 16 * 100%);
        }

        &.ratio-8-6::after {
            content: '';
            display: block;
            padding-top: calc(6 / 8 * 100%);
        }
    }

    .media-error {
        /* TODO */
    }

    .media-caption {
        margin: 20px;
    }
</style>

<style lang="scss">
    .lightbox-media-gallery-slide .media-fixed-ratio iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// media-gallery-slide.vue?65a7a8a0